<template>
  <main>
    <div class="recommend_area account_area d-grid">
      <div class="account_wrap">
        <div class="account_wrap-container">
          <h5 class="account_title">
            {{ $t("Bao.user-friend") }}
          </h5>
          <div class="recommend_info d-flex justify-content-between">
            <span class="d-grid align-items-center justify-content-between">
              <h5 class="mb-0">
                {{ $t("Bao.cumulative_registered_number") }}
              </h5>
              <h6 class="mb-0">
                <b>
                  {{ detail.children_count }}
                </b>
              </h6>
            </span>
            <span class="d-grid align-items-center justify-content-between">
              <h5 class="mb-0">
                {{ $t("Bao.cumulative_deposit_number") }}
              </h5>
              <h6 class="mb-0">
                <b>
                  {{ detail.children_deposit_count }}
                </b>
              </h6>
            </span>
          </div>
          <div class="recommend_info_area d-grid">
            <div class="recommend_info_list d-grid align-items-center">
              <h5 class="mb-0">
                {{ $t("Bao.promotion_link") }}：
              </h5>
              <a
                class="d-block"
                @click="copyText(detail.promotion_url)"
              >{{ detail.promotion_url }}
              </a>
            </div>
            <div class="recommend_info_list d-grid align-self-start">
              <h5 class="mb-0">
                {{ $t("Bao.promotion_code") }}：
              </h5>
              <h6 class="mb-0">
                <small>
                  {{ detail.promotion_code }}
                </small>
                <span>
                  {{ $t("Bao.use_promotion_code_explain") }}
                </span>
              </h6>
            </div>
            <div class="recommend_info_list d-grid align-items-start">
              <h5 class="mb-0">
                {{ $t("Bao.promotion_QR_code") }}：
              </h5>
              <img :src="detail.promotion_image" width="100" height="100" alt="">
            </div>
          </div>
          <div class="recommend_info_btn d-flex">
            <button class="btn btn_copylink" type="button" @click="copyText(detail.promotion_url)">
              <span>{{ $t("Bao.copy_link") }}</span>
            </button>
            <a
              class="btn btn_download"
              :href="detail.promotion_image"
              target="_blank"
              :download="detail.promotion_code + '.webp'"
            >
              <span>
                {{ $t("Bao.download_QR_code") }}
              </span>
            </a>
          </div>
          <br>
          <div v-if="$store.getters.memberInfo && $store.getters.memberInfo.member_type != 0" class="recommend_info_area d-grid">
            <div class="recommend_info_list d-grid align-items-center">
              <h5 class="mb-0">
                {{ $t("Bao.agent_login") }}：
              </h5>
              <a
                class="d-block"
                target="_blank"
                :href="$store.getters.urlInfo.agentUrl"
              >
                {{ $store.getters.urlInfo.agentUrl }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { getPromotionInfo } from '@/api/user'
import { copyText, showNotice } from '@/utils/tool'
import { getShortUrl } from '@/api/common'

export default {
  data() {
    return {
      detail: {},
      copyText: copyText
    }
  },
  created() {
    getPromotionInfo().then(res => {
      this.detail = res.data.data
      const data = {
        signature: '0d8aa9c601',
        action: 'shorturl',
        format: 'json',
        url: 'https://' + this.detail.promotion_url
      }
      this.detail.promotion_url = ''
      const url = 'https://bonus365.nl/yourls-api.php?' + new URLSearchParams(data)

      getShortUrl(url).then(response => {
        this.detail.promotion_url = response.data.shorturl
      }).catch(() => {
        this.detail = res.data.data
      })
    }).catch((error) => {
      showNotice(error.response.data.msg)
    })
  }
}
</script>

<style>

</style>
